import { useFlag } from '@calendly/feature-check-react'
import { useSelector, useDispatch } from 'react-redux'

import { useUpgradeSubscription } from 'components/billing/use_upgrade_subscription'
import { ANALYTICS_CTA_CLICK_PROPS_MAP } from 'components/empty_state/constants'
import { useProductRefreshAppShell } from 'features/app_shell/product_refresh/useProductRefreshAppShell'
import { isOnTrialStageSelector, isAvailableFeatureSelector } from 'features/billing'
import { CONTENT_PAGES } from 'features/empty_state'
import { useIsSmsDeactivated } from 'features/organization_settings'
import { useTrack, TRACKING_EVENT_NAMES } from 'hooks/analytics_events'
import {
  SMS_TO_HOST_TEMPLATES,
  SMS_TO_INVITEE_TEMPLATES,
  shouldBlockTrialSMSForPublisher,
  isSmsTemplate
} from 'services/workflows/templates'
import {
  appNewWorkflowFromTemplateUrl,
} from 'services/workflows/url'


import { TileButton } from './tile_button'
import { openSmsDeactivatedPopup } from '../../modals'

export const TemplateTile = ({ owner,
  id,
  name,
  description,
  icon,
  backTo,
  isEmptyState,
  i18n_prefix: i18nPrefix }) => {
  const isTrial = useSelector(isOnTrialStageSelector)
  const isWorkflowsAppShellRebrand = useProductRefreshAppShell()

  const isSmsDeactivated = useIsSmsDeactivated()
  const smsBlockedState = isSmsTemplate(id) && isSmsDeactivated
  const smsPublisherPaywallFeatureFlagEnabled = useFlag('trust_and_safety_sms_publisher_paywall_feature')

  const onClickUrl = appNewWorkflowFromTemplateUrl(owner, id, backTo, isWorkflowsAppShellRebrand)

  const dispatch = useDispatch()
  const track = useTrack()
  const upgradeSubscription = useUpgradeSubscription({ featureKey: 'sms_to_invitee_workflows' })
  const isFeatureAvailable = useSelector((state) => isAvailableFeatureSelector(state, { featureKey: 'workflows' }))
  const shouldBlockSmsToInvitee = SMS_TO_INVITEE_TEMPLATES.includes(id)
    && (isTrial || !isFeatureAvailable)
  const shouldBlockSmsToPublisher = SMS_TO_HOST_TEMPLATES.includes(id)
    && (shouldBlockTrialSMSForPublisher(isTrial, smsPublisherPaywallFeatureFlagEnabled) || !isFeatureAvailable)

  const onClick = (evt) => {
    if (isEmptyState) {
      const properties = (
        ANALYTICS_CTA_CLICK_PROPS_MAP[isEmptyState]
          || ANALYTICS_CTA_CLICK_PROPS_MAP[CONTENT_PAGES.workflows]
      )
      track({
        name: TRACKING_EVENT_NAMES.CTA_CLICKED,
        entities: ['attribution', 'organization', 'user'],
        properties: {
          ...properties,
          cta_destination: properties.cta_destination || i18nPrefix,
        },
      })
    }

    if (smsBlockedState) {
      evt.persist()
      evt.preventDefault()
      evt.stopPropagation()

      dispatch(openSmsDeactivatedPopup())
      return
    }

    if (shouldBlockSmsToInvitee || shouldBlockSmsToPublisher) {
      evt.persist()
      evt.preventDefault()
      evt.stopPropagation()

      upgradeSubscription()
    }
  }

  return (
    <TileButton
      data-testid={`workflows-cta-${id}`}
      as="a"
      onClick={onClick}
      href={onClickUrl}
      icon={icon}
      name={name}
      description={description}
      smsBlocked={smsBlockedState}
    />
  )
}
